<template>
    <SeoHead title="Login" noindex />
  <div class="p-6 min-h-screen flex justify-center items-center light">
      <flash-messages />
    <div class="w-full max-w-md">
        <Link :href="route('home')"><logo class="block mx-auto w-full max-w-xs fill-white" height="50" /></Link>
      <form class="mt-8 bg-white dark:bg-slate-900 border border-gray-100 rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h2 class="text-center font-bold text-xl">{{ __('Login - Support Center!') }}</h2>
          <div class="mx-auto mt-3 w-24 border-b" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />
          <label class="mt-6 select-none flex items-center" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Remember Me</span>
          </label>
            <loading-button :loading="form.processing" class="ml-auto btn-indigo w-full items-center justify-center mt-8" type="submit">{{ __('Login') }}</loading-button>
            <div class="mt-5 flex justify-center"><Link class="ml-2 " :href="route('password.reset')">{{ __('Forgot your password?') }}</Link></div>
            <div class="mt-5 flex justify-center">Don’t have account? <Link class="ml-2 " :href="route('register')">{{ __('Register') }}</Link></div>
        </div>
          <div class="py-5 px-10 bg-gray-100 dark:bg-slate-900 border-t border-gray-100 dark:border-gray-700 w-full" v-if="is_demo && demo_users.length">
              <h2 class="text-sm font-bold text-center mb-3">{{ __('Demo Credentials') }}</h2>
              <div class="space-y-2">
                  <div
                    v-for="demo_user in demo_users"
                    :key="demo_user.email"
                    class="flex items-center justify-between gap-3 bg-white dark:bg-slate-800 rounded-md border border-gray-200 dark:border-gray-700 px-3 py-2"
                  >
                      <div class="text-xs leading-tight">
                          <div class="font-semibold">{{ demo_user.label }}</div>
                          <div class="text-gray-500 dark:text-gray-400">{{ demo_user.email }} / {{ demo_user.password }}</div>
                      </div>
                      <button type="button" class="btn-indigo text-sm px-3 py-1.5 shrink-0" @click="autofillLogin($event, demo_user)">
                          {{ __('Use') }}
                      </button>
                  </div>
              </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SeoHead from '@/Shared/SeoHead'
import { Link } from '@inertiajs/vue3'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
      FlashMessages,
    LoadingButton,
    Logo,
    TextInput,
      SeoHead,
      Link,
  },
    props: {
        is_demo: Number,
        demo_users: {
            type: Array,
            default: () => [],
        },
    },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
      login() {
          this.form.post(this.route('login.store'))
      },
      autofillLogin(e, demo_user){
          e.preventDefault()
          this.form.email = demo_user.email
          this.form.password = demo_user.password
          this.login();
      }
  }
}
</script>
